// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QJ_mAx84UqEwF0q8ydYF{width:290px}.JAt125fG0otnLpigZUdj{border-top:1px var(--border-neutral-default)solid;padding:4px}.NTLR699LbZsmkHiHiN1u,.IJhFBOUa50QnhRFQ1TVg{justify-content:center;align-items:center;padding:15px;display:flex}.X9xV_SlnSQ8efvrSlm1w{height:100%;color:var(--content-primary-primary);text-overflow:ellipsis;padding:4px;font-size:13px;font-weight:400}.OVGfyuNDx854YMATYT86{background:var(--background-primary-inverted-primary);border:none;border-radius:6px;outline:none;padding:12px}.sdTOPNFhLA45JM7rlsYe{border-bottom:1px solid var(--border-neutral-default)}._kdwg00IMNkvtxUBujnK{background-color:var(--border-neutral-default);width:100%;height:1px;margin:4px 0}.XGYWc_jDYSUK9oGXCdn8{color:var(--gray-60);justify-content:center;align-items:center;padding:15px;display:flex}._KbdPeIYux0dgnU8PY7m{padding:8.5px 12px;display:inline-block}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `QJ_mAx84UqEwF0q8ydYF`,
	"clear": `JAt125fG0otnLpigZUdj`,
	"spinner": `NTLR699LbZsmkHiHiN1u`,
	"epmtyList": `IJhFBOUa50QnhRFQ1TVg`,
	"list": `X9xV_SlnSQ8efvrSlm1w`,
	"search": `OVGfyuNDx854YMATYT86`,
	"searchWrap": `sdTOPNFhLA45JM7rlsYe`,
	"divider": `_kdwg00IMNkvtxUBujnK`,
	"emptyList": `XGYWc_jDYSUK9oGXCdn8`,
	"limitInfo": `_KbdPeIYux0dgnU8PY7m`
};
export default ___CSS_LOADER_EXPORT___;
